import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Tooltip,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FILTER_TYPES } from "../constants";

const selectSx = {
  minWidth: 118,
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    bgcolor: "#fff",
    fontSize: 13,
    height: 36,
  },
  "& .MuiInputLabel-root": { fontSize: 13 },
};

export const CalendarFilters = ({
  filterType,
  filterValue,
  filterOptions,
  onFilterTypeChange,
  onFilterValueChange,
  onClear,
  events,
}) => {
  const hasActiveFilter = filterType && filterValue;
  const filteredCount = events?.length || 0;

  return (
    <Box display="flex" alignItems="center" gap={0.75} flexWrap="nowrap">
      <FormControl size="small" sx={selectSx}>
        <InputLabel>Filtro</InputLabel>
        <Select
          label="Filtro"
          value={filterType || ""}
          displayEmpty
          onChange={(e) => {
            const next = e.target.value;
            if (!next) {
              onClear();
              return;
            }
            onFilterTypeChange(next);
            onFilterValueChange("");
          }}
        >
          <MenuItem value="">
            <em>Todos</em>
          </MenuItem>
          <MenuItem value={FILTER_TYPES.TECHNICIAN}>Técnico</MenuItem>
          <MenuItem value={FILTER_TYPES.ZONE}>Zona</MenuItem>
        </Select>
      </FormControl>

      {filterType ? (
        <FormControl
          size="small"
          sx={{ ...selectSx, minWidth: 160 }}
          disabled={filterOptions.length === 0}
        >
          <InputLabel>{filterType === FILTER_TYPES.ZONE ? "Zona" : "Técnico"}</InputLabel>
          <Select
            label={filterType === FILTER_TYPES.ZONE ? "Zona" : "Técnico"}
            value={filterValue || ""}
            onChange={(e) => onFilterValueChange(e.target.value)}
          >
            {filterOptions.length === 0 ? (
              <MenuItem disabled value="">
                Sin opciones
              </MenuItem>
            ) : (
              filterOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>
      ) : null}

      {hasActiveFilter ? (
        <>
          <Chip
            label={filteredCount}
            size="small"
            sx={{
              height: 22,
              fontWeight: 700,
              fontSize: 11,
              bgcolor: "#F3F4F6",
            }}
          />
          <Tooltip title="Quitar filtro">
            <IconButton size="small" onClick={onClear} sx={{ color: "#6B7280" }}>
              <CloseIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        </>
      ) : null}
    </Box>
  );
};
